import React from 'react'
import { MainGenerateQR } from '../../layouts/MainGenerateQR/MainGenerateQR'

export const GeneraeteQR = () => {
  return (
    <MainGenerateQR />
  )
}
